<script lang="ts">
  import SideSection from "$lib/ui/docs/SideSection.svelte";
  import ThreeColumn from "$lib/ui/docs/ThreeColumn.svelte";
  import sections from "./sections.json";
</script>

<ThreeColumn>
  <svelte:fragment slot="sidebar-links">
    {#each sections as section}
      <SideSection {section} />
    {/each}
  </svelte:fragment>
  <slot />
</ThreeColumn>
